import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { SystemFieldTypes } from "@graylog/server-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  fieldTypes: {}
};
const fetchFieldTypes = async () => {
  const fieldTypes = await SystemFieldTypes.getAllFieldTypes();
  return { fieldTypes };
};
const useFieldTypesForMappings = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["fieldTypeOptions"],
    queryFn: () => defaultOnError(
      fetchFieldTypes(),
      i18n.t("change_field_type.load_field_type_options_failed", { ns: "search" }),
      i18n.t("change_field_type.could_not_load_field_type_options", { ns: "search" })
    ),
    placeholderData: keepPreviousData
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isLoading
  };
};
export default useFieldTypesForMappings;
